module.exports = __webpack_public_path__ + "media/images/pc/specials/common/plan_waso_studio_plus-8eb64f555f8fd6d52f3c0fb0f04a9423.jpg";